import { supabase } from './supabase'

const ACTIVE_STUDENT_KEY = 'parent_active_student_id'

export async function fetchParentStudents(userId) {
  const { data: parent, error: parentError } = await supabase
    .from('parents')
    .select('id, student_id, student_ids')
    .eq('id', userId)
    .single()

  if (parentError || !parent) {
    return { parent: null, students: [], error: parentError }
  }

  const ids = Array.from(new Set([
    ...(Array.isArray(parent.student_ids) ? parent.student_ids : []),
    ...(parent.student_id ? [parent.student_id] : []),
  ].filter(Boolean)))

  if (!ids.length) {
    return { parent, students: [], error: null }
  }

  const { data: students, error: studentsError } = await supabase
    .from('students')
    .select('id, name, student_code, grade, group_id, groups(name, day, time)')
    .in('id', ids)
    .order('name')

  if (studentsError) {
    return { parent, students: [], error: studentsError }
  }

  const byId = new Map((students || []).map(s => [s.id, s]))
  const ordered = ids.map(id => byId.get(id)).filter(Boolean)

  return {
    parent,
    students: ordered,
    error: null
  }
}

export function getActiveStudentId(students) {
  if (!students?.length) return null

  const saved = localStorage.getItem(ACTIVE_STUDENT_KEY)

  if (saved && students.some(s => s.id === saved)) {
    return saved
  }

  const firstId = students[0].id
  localStorage.setItem(ACTIVE_STUDENT_KEY, firstId)

  return firstId
}

export function setActiveStudentId(studentId) {
  localStorage.setItem(ACTIVE_STUDENT_KEY, studentId)
  window.dispatchEvent(new Event('parent-student-changed'))
}